module.exports = __webpack_public_path__ + "media/icons/tapicerka-materialowa-uactive-4cbe56de.png";